import { WarningCircle } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { friendlyErrorKey } from '@/lib/api/friendly-errors'

interface ErrorStateProps {
  error?: unknown
  titleKey?: string
  bodyKey?: string
  onRetry?: () => void
  retryLabelKey?: string
}

export function ErrorState({
  error,
  titleKey = 'common.errorTitle',
  bodyKey,
  onRetry,
  retryLabelKey = 'common.retry',
}: ErrorStateProps) {
  const { t } = useTranslation()
  const messageKey = bodyKey ?? (error ? friendlyErrorKey(error) : 'common.errorBody')

  return (
    <div
      role="alert"
      className="mx-auto flex max-w-xl flex-col items-center gap-4 rounded-md border border-line bg-white p-6 text-center"
    >
      <WarningCircle
        size={32}
        weight="bold"
        aria-hidden="true"
        className="text-danger"
      />
      <div className="space-y-2">
        <h2 className="text-2xl">{t(titleKey)}</h2>
        <p className="text-muted">{t(messageKey)}</p>
      </div>
      {onRetry ? (
        <button type="button" className="btn-secondary" onClick={onRetry}>
          {t(retryLabelKey)}
        </button>
      ) : null}
    </div>
  )
}
